<template>
  <div id="content-container" v-if="product">
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="成品详情">
      </el-page-header>
      <el-descriptions title="" size="small">
        <el-descriptions-item label="名称">{{
          product.name
        }}</el-descriptions-item>
        <el-descriptions-item label="编号">{{
          product.code
        }}</el-descriptions-item>
        <el-descriptions-item label="历史编号">{{
          (product.history_codes || ['无']).join('、')
        }}</el-descriptions-item>
        <el-descriptions-item
          :label="param.label"
          v-for="param in product.custom_params"
          :key="param.key"
        >
          {{ param.value }}
        </el-descriptions-item>
        <el-descriptions-item label="组装基地">
          {{ product.install_base.name }}
        </el-descriptions-item>
        <el-descriptions-item label="发往基地" v-if="product.category == 1">
          {{ product.base.name }}
        </el-descriptions-item>
        <el-descriptions-item label="库存基地" v-if="product.category == 2">
          <div>
            {{ product.base.name || '无' }}
          </div>
          <div class="text-danger" v-if="product.receive_base_id">
            {{ `（待${product.receive_base.name}接收）` }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="发往钻井" v-if="product.category == 2">
          <div>
            {{ product.drill_well.well_number || '无' }}
          </div>
          <div class="text-danger" v-if="product.receive_well_id">
            {{ `（待${product.receive_well.well_number}接收）` }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <ItemStatus :status="product.status" model="product"></ItemStatus>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ product.remark }}
        </el-descriptions-item>
      </el-descriptions>
      <template
        v-if="
          product.category == 2 &&
          product.status == 2 &&
          $store.state.userInfo.base_id
        "
      >
        <el-button
          v-if="
            !product.receive_base_id &&
            !product.drill_well_id &&
            !product.receive_well_id &&
            product.base_id == $store.state.userInfo.base_id
          "
          type="primary"
          size="mini"
          plain
          v-permission="Auth.instrumentStockManage"
          @click="itemStockOut()"
          >出库{{
        }}</el-button>
        <el-popconfirm
          v-if="
            product.base_id == $store.state.userInfo.base_id &&
            ((product.receive_base_id && !product.receive_well_id) ||
              (product.receive_well_id &&
                product.receive_well_id == product.drill_well_id))
          "
          title="确认撤回该成品吗？"
          @confirm="itemStockRecall()"
        >
          <el-button
            size="mini"
            plain
            slot="reference"
            v-permission="Auth.instrumentStockManage"
            type="danger"
            class="mr-10"
            >撤回</el-button
          >
        </el-popconfirm>

        <el-button
          v-if="product.receive_base_id == $store.state.userInfo.base_id"
          v-permission="Auth.instrumentStockManage"
          plain
          size="mini"
          type="danger"
          class="mr-10"
          @click="itemStockReject()"
          >拒收</el-button
        >
        <el-popconfirm
          v-if="
            !product.base_id ||
            (product.receive_base_id == $store.state.userInfo.base_id &&
              product.drill_well_id == 0)
          "
          title="确认入库该成品吗？"
          @confirm="itemStockIn()"
        >
          <el-button
            size="mini"
            plain
            slot="reference"
            v-permission="Auth.instrumentStockManage"
            type="danger"
            class="mr-10"
            >确认入库</el-button
          >
        </el-popconfirm>
        <el-button
          size="mini"
          plain
          v-if="
            product.base_id == $store.state.userInfo.base_id &&
            !product.receive_base_id &&
            !product.receive_well_id &&
            !product.drill_well_id
          "
          type="primary"
          class="mr-10"
          v-permission="Auth.instrumentStockManage"
          @click="itemSendToWell()"
          >发往钻井</el-button
        >
        <el-popconfirm
          v-if="
            product.receive_base_id == $store.state.userInfo.base_id &&
            product.drill_well_id > 0
          "
          title="确认该成品已从钻井返回吗？"
          @confirm="itemReceiveConfirm()"
        >
          <el-button
            size="mini"
            plain
            slot="reference"
            v-permission="Auth.instrumentStockManage"
            type="danger"
            class="mr-10"
            >确认接收</el-button
          >
        </el-popconfirm>
      </template>

      <el-button
        v-permission="
          product.category == 1 ? Auth.productEdit : Auth.instrumentEdit
        "
        type="primary"
        size="mini"
        plain
        @click="editProduct"
        >编辑</el-button
      >
      <el-button
        type="primary"
        size="mini"
        class="mt-10"
        plain
        @click="handleFinishInstall"
        v-if="product.status == 1"
        v-permission="
          product.category == 1 ? Auth.productInstall : Auth.instrumentInstall
        "
        >完成装配</el-button
      >
      <el-button
        type="primary"
        size="mini"
        class="mt-10"
        plain
        @click="handleDisassemb()"
        v-if="
          product.status == 2 &&
          !product.drill_well_id &&
          !product.receive_well_id &&
          !product.receive_base_id
        "
        v-permission="
          product.category == 1
            ? Auth.productDisassemble
            : Auth.instrumentDisassemble
        "
        >成品拆卸</el-button
      >
      <!-- <el-button
        type="primary"
        size="mini"
        class="mt-10"
        plain
        @click="handleStockIn({}, -2)"
        v-if="product.status == 2"
        v-permission="
          product.category == 1
            ? Auth.productAddUseRecord
            : Auth.instrumentAddUseRecord
        "
        >添加使用记录</el-button
      > -->
      <el-button
        size="mini"
        type="primary"
        plain
        @click="addRepairRecord()"
        v-permission="
          product.category == 1
            ? Auth.productAddRepairRecord
            : Auth.instrumentAddRepairRecord
        "
        >添加维修记录</el-button
      >
    </div>

    <div class="panel">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="配件列表" name="tab1">
          <el-button
            type="primary"
            size="mini"
            @click="addItemFormerVisible = true"
            v-if="product.status == 1"
            v-permission="
              product.category == 1
                ? Auth.productAddItem
                : Auth.instrumentAddItem
            "
            >添加配件</el-button
          >
          <el-table class="m-t-10" :data="productItems" border size="small">
            <el-table-column
              label="序号"
              type="index"
              align="center"
            ></el-table-column>
            <el-table-column
              label="名称"
              prop="item_template.name"
              align="center"
            ></el-table-column>
            <el-table-column label="编号" prop="item.code" align="center">
              <template slot-scope="scope">
                <ItemLink :model="scope.row.item">
                  {{ scope.row.item.code }}
                </ItemLink>
              </template>
            </el-table-column>
            <el-table-column
              label="型号"
              prop="item.model_number"
              align="center"
            ></el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <ItemStatus
                  :status="scope.row.status"
                  model="productItem"
                ></ItemStatus>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div
                  v-if="
                    !scope.row.item_id &&
                    (installIndex == -1 || installIndex != scope.$index)
                  "
                >
                  <el-popconfirm
                    title="确定删除该配件吗？"
                    @confirm="handleItemDelete(scope.row, scope.$index)"
                  >
                    <el-link
                      slot="reference"
                      type="danger"
                      class="font-12"
                      :underline="false"
                      v-permission="
                        product.category == 1
                          ? Auth.productDeleteItem
                          : Auth.instrumentDeleteItem
                      "
                      >删除</el-link
                    >
                  </el-popconfirm>
                  <el-link
                    type="primary"
                    class="font-12 ml-5"
                    :underline="false"
                    v-permission="
                      product.category == 1
                        ? Auth.productInstallItem
                        : Auth.instrumentInstallItem
                    "
                    @click="installIndex = scope.$index"
                    >选择配件</el-link
                  >
                </div>
                <div style="display: flex" v-if="installIndex == scope.$index">
                  <ItemSelect
                    @input="
                      handleUpdateProductItem($event, scope.$index, scope.row)
                    "
                    :status="1"
                    :category="product.category"
                    :templateid="scope.row.item_template_id"
                    :install="true"
                    v-if="!scope.row.item_id"
                  ></ItemSelect>
                  <el-link
                    style="min-width: 40px"
                    type="primary"
                    class="font-12 ml-5"
                    :underline="false"
                    @click="installIndex = -1"
                    >取消</el-link
                  >
                </div>
                <el-button
                  plain
                  type="danger"
                  size="mini"
                  v-if="
                    scope.row.item_id &&
                    !product.drill_well_id &&
                    !product.receive_base_id
                  "
                  v-permission="
                    product.category == 1
                      ? Auth.productItemDisassemble
                      : Auth.instrumentItemDisassemble
                  "
                  @click="handleStockIn(scope.row, scope.$index)"
                >
                  拆卸
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="使用记录" name="tab2">
          <ProductRecords
            :product="product"
            :category="11"
            v-if="product.id"
            ref="tab2"
          ></ProductRecords>
        </el-tab-pane>
        <el-tab-pane label="拆检记录" name="tab5">
          <ProductRecords
            :product="product"
            :category="6"
            v-if="product.id"
            ref="tab5"
          ></ProductRecords>
        </el-tab-pane>
        <el-tab-pane label="维修记录" name="tab3">
          <ProductRecords
            :product="product"
            :category="7"
            v-if="product.id"
            ref="tab3"
          ></ProductRecords>
        </el-tab-pane>
        <el-tab-pane label="配件保养/更换记录" name="tab6">
          <ProductRecords
            :product="product"
            :category="4"
            v-if="product.id"
            ref="tab6"
          ></ProductRecords>
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="tab4">
          <ProductRecords
            :product="product"
            :show-export="true"
            v-if="product.id"
          ></ProductRecords>
        </el-tab-pane>
      </el-tabs>
    </div>

    <AddItemFormer
      v-if="addItemFormerVisible"
      :model="productItem"
      :show.sync="addItemFormerVisible"
      @created="addItemCallback"
    ></AddItemFormer>

    <StockinFormer
      :model="stockinModel"
      :category="product.category"
      :show.sync="stockinVisible"
      @updated="stockinCallback"
    ></StockinFormer>

    <DisassembFormer
      :model="model"
      :show.sync="disassembVisible"
      @updated="stockinCallback"
    ></DisassembFormer>

    <InstallFormer
      :model="finishInstallModel"
      :show.sync="finishInstallVisible"
      @updated="productFinishInstall"
    ></InstallFormer>

    <EditFormer
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></EditFormer>

    <StockoutFormer
      :model="model"
      :show.sync="stockoutFormerVisible"
      @updated="updatedCallback"
    ></StockoutFormer>

    <WellFormer
      :model="model"
      :show.sync="wellFormerVisible"
      @updated="updatedCallback"
    ></WellFormer>

    <RepairFormer
      :model="model"
      :show.sync="repairFormerVisible"
      @created="repairRecordCreated"
    ></RepairFormer>
  </div>
</template>

<script>
import {
  productDetail,
  productItemUpdate,
  productItemDelete,
  productStockIn,
  productReceiveComfirm,
  productRecall,
  productReject,
} from '@/service/getData'
import AddItemFormer from './add_item_former'
import StockoutFormer from './stockout_former'
import StockinFormer from './used_former'
import DisassembFormer from './disassemb_former'
import RepairFormer from './repair_former'
import ProductRecords from './product_records'
import InstallFormer from './install_former'
import ItemSelect from '@/components/select/item_select'
import EditFormer from './former'
import WellFormer from './well_former'

export default {
  components: {
    AddItemFormer,
    StockoutFormer,
    WellFormer,
    StockinFormer,
    RepairFormer,
    ProductRecords,
    InstallFormer,
    ItemSelect,
    EditFormer,
    DisassembFormer,
  },
  data() {
    return {
      activeTab: 'tab1',
      product: null,
      stockinModel: {},
      stockinVisible: false,
      disassembVisible: false,
      stockinIndex: -1,
      productItem: {
        product_id: '',
        item_id: '',
        category: 0,
      },
      stockoutFormerVisible: false,
      wellFormerVisible: false,
      addItemFormerVisible: false,
      finishInstallVisible: false,
      finishInstallModel: {},
      installIndex: -1,
      formerVisible: false,
      repairFormerVisible: false,
      model: {},
    }
  },
  computed: {
    productItems() {
      let items = this.product.items.sort(function (x, y) {
        return x.item_template.sort - y.item_template.sort
      })
      return items
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await productDetail(this.$route.params.id)
      if (res.status != 0) return
      this.product = res.data
      this.productItem.product_id = this.product.id
      this.productItem.category = this.product.category
    },
    editProduct() {
      this.model = this.clone(this.product)
      this.model.custom_params = this.copyCustomParam(
        this.product.template.custom_params,
        this.product.custom_params,
      )
      this.formerVisible = true
    },
    updatedCallback() {
      this.getData()
    },
    async handleItemDelete(item, index) {
      let res = await productItemDelete(item.id)
      if (res.code == 0) {
        this.product.items.splice(index, 1)
      }
    },
    addItemCallback(item) {
      this.installIndex = -1
      this.product.items.unshift(item)
    },
    productFinishInstall(data) {
      this.product = data
    },
    async handleUpdateProductItem(e, index, item) {
      let res = await productItemUpdate({
        id: item.id,
        item_id: e,
      })

      if (res.code == 0) {
        this.product = res.data
        // this.$set(this.product.items, index, res.data)
        this.installIndex = -1
      }
    },
    handleFinishInstall() {
      if (this.product.items.filter((item) => item.status == 1).length > 0) {
        this.$alert('请先完成所有配件的装配！')
        return
      }
      this.finishInstallModel = {
        id: this.product.id,
        operate_date: '',
        imgs: [],
        remark: '',
      }
      this.finishInstallVisible = true
    },
    handleStockIn(item, index) {
      let used_extra = [
        { key: 'block', value: '', label: '使用区块' },
        { key: 'well_team_number', value: '', label: '井队号' },
        { key: 'well_number', value: '', label: '井号' },
      ]
      this.stockinIndex = item.id ? index : -1
      this.stockinModel = {
        id: item.id ? item.id : this.product.id,
        only_add_record: index == -2,
        base_id: '',
        type: item.id ? 2 : 1,
        operate_date: '',
        used_date: '',
        used_hour: 0,
        used_extra: used_extra,
        imgs: [],
        videos: [],
        remark: '',
      }
      this.stockinVisible = true
      if (!item.id) {
        this.activeTab = 'tab2'
      }
    },
    handleDisassemb() {
      let item_records = this.productItems
        .filter((pi) => pi.item_id > 0)
        .map((pi) => {
          return {
            name: pi.item.name,
            code: pi.item.code,
            item_id: pi.item_id,
            imgs: [],
            videos: [],
            inspection: '',
          }
        })

      this.model = {
        id: this.product.id,
        is_used: '', //是否使用过
        base_id: '',
        operate_date: '',
        imgs: [],
        videos: [],
        inspection: '',
        item_records: item_records,
      }
      this.disassembVisible = true
      this.activeTab = 'tab5'
    },
    addRepairRecord() {
      this.model = {
        product_id: this.product.id,
        category: 7,
        used_date: '',
        usage: '',
        inspection: '',
        solution: '',
        imgs: [],
        videos: [],
        remark: '',
      }
      this.repairFormerVisible = true
      this.activeTab = 'tab3'
    },
    repairRecordCreated(product) {
      this.product.id = 0
      this.getData()
    },
    stockinCallback(data) {
      this.product.id = 0
      this.getData()
      // this.product = data
      // if (this.stockinIndex >= 0) {
      //   this.$set(this.product.items, this.stockinIndex, data)
      // } else {
      //   this.product = data
      // }
    },
    itemStockOut() {
      this.model = {
        receive_base_id: '',
        id: this.product.id,
      }
      this.stockoutFormerVisible = true
    },
    async itemStockIn() {
      let res = await productStockIn({ id: this.product.id })
      if (res.code == 0) {
        this.updatedCallback()
      }
    },
    itemSendToWell() {
      this.model = {
        base_id: this.product.base_id,
        receive_well_id: '',
        id: this.product.id,
      }
      this.wellFormerVisible = true
    },
    async itemReceiveConfirm() {
      let res = await productReceiveComfirm({ id: this.product.id })
      if (res.code == 0) {
        this.updatedCallback()
      }
    },

    // 撤回
    async itemStockRecall() {
      let res = await productRecall({
        id: this.product.id,
      })
      if (res.code == 0) {
        this.$notify.success('已撤回！')
        this.updatedCallback()
      }
    },

    //拒收
    itemStockReject() {
      this.$prompt('拒收原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => {
          return !!value
        },
        inputErrorMessage: '拒收原因不能为空',
      }).then(async ({ value }) => {
        let res = await productReject({
          id: this.product.id,
          remark: value,
        })
        if (res.code == 0) {
          this.$notify.success('已拒收！')
          this.updatedCallback()
        }
      })
    },
  },
}
</script>

<style scoped>
.title {
  font-size: 16px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
</style>